import {StateProvider as TestStateProvider} from '@components/Test/Context';
import Question from '@components/Test/Question';
import {POINTS} from '@constants/test';
import type {Question as QuestionType} from '@interfaces/Test';
import type {ReactElement} from 'react';

interface Props {
    id: string;
    type?: string;
    question: QuestionType;
    isVertical?: boolean;
}

export default function Reaction(props: Props): ReactElement<Props> {
    return (
        <TestStateProvider value={{id: props.id, type: props.type ?? POINTS, showStats: true}}>
            <div className="test-question">
                <Question {...props.question} isVertical={props.isVertical} />
            </div>
        </TestStateProvider>
    );
}
